import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import Router from 'vue-router';
import Meta from 'vue-meta';

import { updateUserNavigationInfo } from '@/services/api/authentication_service';

import paths from './paths';

function route(pathObject) {
  const { path, view, name, title, layout, children, beforeEnter, isAdmin } = pathObject;
  return {
    name: name || view,
    path,
    meta: {
      title,
      layout,
      isAdmin,
    },
    component: (resovle) => import(`@/views/${view}.vue`).then(resovle),
    children:
      (children &&
        children.map((child) => {
          return route(child);
        })) ||
      [],
    beforeEnter,
  };
}

const routes = paths.map((path) => route(path));

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
});

router.afterEach(() => {
  setTimeout(updateUserNavigationInfo, 7000);
});

Vue.use(Meta);

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development',
    },
  });
}

export default router;
